// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ilapizvelnriuufhhbam.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlsYXBpenZlbG5yaXV1ZmhoYmFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc1MjM4MTcsImV4cCI6MjA3MzA5OTgxN30.76ul_az2psE6undQgN2J6KbrNl_WYLFxaxfCWQ2eJU4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});